//ORGANIZATION MANAGEMENT ACTION TYPES
export const GET_ALL_ASSETS = "GET_ALL_ASSETS";
export const GET_ALL_REQUESTS = "GET_ALL_REQUESTS";
export const GET_ASSETS_CAT = "GET_ASSETS_CAT";
export const GET_ALL_EXPENDITURES = "GET_ALL_EXPENDITURES";
export const GET_REQUEST = "GET_REQUEST";
export const GET_PENDING_LEAVES = "GET_PENDING_LEAVES";
export const GET_PENDING_REQUESTS = "GET_PENDING_REQUESTS";

//EMPLOYEE MANAGEMENT ACTION TYPES
export const CREATE_EMPLOYEE = "CREATE_EMPLOYEE";
export const GET_EMPLOYEE_DETAILS = "GET_EMPLOYEE_DETAILS";
export const GET_EMPLOYEE = "GET_EMPLOYEE";
export const GET_DISCIPLINARY_CASE = "GET_DISCIPLINARY_CASE";
export const GET_ALL_CASE = "GET_ALL_CASE";
export const GET_INACTIVE_EMPLOYEE = "GET_INACTIVE_EMPLOYEE";
export const GET_WHO_IS_OUT_EMPLOYEE = "GET_WHO_IS_OUT_EMPLOYEE";

//HOLIDAYS MANAGEMENT ACTION TYPES
export const GET_ALL_HOLIDAYS = "GET_ALL_HOLIDAYS";
export const GET_ALL_LEAVE_RECORD = "GET_ALL_LEAVE_RECORD";

//MUCH AND LEARN MANAGEMENT ACTION TYPES
export const GET_ALL_MUCH_AND_LEARN = "GET_ALL_MUCH_AND_LEARN";
export const GET_ALL_THEME_OF_THE_WEEK = "GET_ALL_THEME_OF_THE_WEEK";

//MUCH AND LEARN MANAGEMENT ACTION TYPES
export const GET_ALL_NOTIFICATIONS = "GET_ALL_NOTIFICATIONS";
export const GET_UNREAD_NOTIFICATIONS = "GET_UNREAD_NOTIFICATIONS";
export const GET_READ_NOTIFICATION = "GET_READ_NOTIFICATION";

//REPORTING MANAGEMENT ACTION TYPES
export const GET_REPORTING = "GET_REPORTING";

//SYSTEM CONFIGURATION ACTION TYPES
export const GET_ALL_LEAVES = "GET_ALL_LEAVES";
export const GET_ROLES = "GET_ROLES";
export const GET_JOB_TITLES = "GET_JOB_TITLES";
export const GET_OFFICES = "GET_OFFICES";
export const GET_EVENT_CAT = "GET_EVENT_CAT";
export const GET_SUBCATEGORIES = "GET_SUBCATEGORIES";

//PERFORMANCE MANAGEMENT ACTION TYPES
export const GET_EVENT = "GET_EVENT";
export const GET_EMPLOYEE_APPARAISAL = "GET_EMPLOYEE_APPARAISAL";
export const GET_PERFORMANCE_REVIEW = "GET_PERFORMANCE_REVIEW";
export const VIEW_EMPLOYEE_APPARAISAL = "VIEW_EMPLOYEE_APPARAISAL";

//ACTIVITY LOGS ACTION TYPES
export const GET_ACTIVITY_LOGS = "GET_ACTIVITY_LOGS";

//SESSION EXPIRED
export const SESSION_EXPIRED = "SESSION_EXPIRED";



// WEBPACK FOOTER //
// ./src/store/actionTypes.js